import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';
import { CardFrame, CardGrid } from '../ui/card';

const IntroSection = () => {
  const { t } = useTranslation();
  const titleRef = useScrollReveal();
  const contentRef = useScrollReveal();
  const imageRef = useScrollReveal();

  return (
    <section className="about-intro">
      <div className="container">
        <div ref={imageRef} className="intro-image-wrapper scroll-reveal">
          <img src="/sampleimg.png" alt={t('about.introSection.title')} className="intro-image" />
        </div>

        <div ref={titleRef} className="intro-header scroll-reveal">
          <h2 className="section-title">{t('about.introSection.title')}</h2>
          <p className="intro-subtitle">
            {t('about.introSection.subtitle')}
          </p>
          <p>
            {t('about.introSection.paragraph1')}
          </p>
          <p>
            {t('about.introSection.paragraph2')}
          </p>
        </div>

        <div ref={contentRef} className="intro-content scroll-reveal">
          <h3>{t('about.introSection.workTitle')}</h3>
          <p className="intro-description">
            {t('about.introSection.workDescription')}
          </p>

          <CardGrid min="250px" gap="2rem" className="work-items">
            <CardFrame
              padding="2rem"
              radius="10px"
              shadow="normal"
              hover="md"
            >
              <h4>{t('about.introSection.work1.title')}</h4>
              <p>{t('about.introSection.work1.desc')}</p>
            </CardFrame>

            <CardFrame
              padding="2rem"
              radius="10px"
              shadow="normal"
              hover="md"
            >
              <h4>{t('about.introSection.work2.title')}</h4>
              <p>{t('about.introSection.work2.desc')}</p>
            </CardFrame>

            <CardFrame
              padding="2rem"
              radius="10px"
              shadow="normal"
              hover="md"
            >
              <h4>{t('about.introSection.work3.title')}</h4>
              <p>{t('about.introSection.work3.desc')}</p>
            </CardFrame>

            <CardFrame
              padding="2rem"
              radius="10px"
              shadow="normal"
              hover="md"
            >
              <h4>{t('about.introSection.work4.title')}</h4>
              <p>{t('about.introSection.work4.desc')}</p>
            </CardFrame>
          </CardGrid>

          <div className="promise-section">
            <h3>{t('about.introSection.promise.title')}</h3>
            <p>
              {t('about.introSection.promise.paragraph1')}
            </p>
            <p>
              {t('about.introSection.promise.paragraph2')}
            </p>
            <p className="highlight-text">
              {t('about.introSection.promise.highlight')}
            </p>
            <p>
              {t('about.introSection.promise.paragraph3')}
            </p>
            <p className="closing-text">
              {t('about.introSection.promise.closing')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
